import { render } from "./CKGame.vue?vue&type=template&id=944e0c7a"
import script from "./CKGame.vue?vue&type=script&lang=js"
export * from "./CKGame.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__